import { guideSteps } from "@/mocks/homeData";

export default function RecoverSection() {
  return (
    <section id="recover" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=stylized%20minimalist%20illustration%20of%20a%20hand%20holding%20a%20smartphone%20with%20a%20rose%20colored%20bookmark%20ribbon%20icon%20floating%20above%20it%2C%20warm%20cream%20background%2C%20soft%20coral%20and%20amber%20accents%2C%20clean%20flat%20vector%20with%20subtle%20grain%2C%20gentle%20spring%20mood&width=1200&height=800&seq=taohua-recover-2026&orientation=landscape"
                alt="手持手机并显示书签图标，示意把导航页收藏起来"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <p className="font-label text-sm text-primary-600 font-medium">找回指引</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
              链接打不开？按这三步找回
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base">
              换域名、改版跳转都属于正常现象。真正省心的做法不是记住某个具体地址，而是记住获取地址的地方。
            </p>

            <div className="mt-7 space-y-3">
              {guideSteps.map((step) => (
                <div
                  key={step.step}
                  className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
                >
                  <div className="flex-shrink-0">
                    <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                      <i className={`${step.icon} text-xl`} />
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="font-heading font-black text-accent-600 text-sm">{step.step}</span>
                      <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950">
                        {step.title}
                      </h3>
                    </div>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 flex items-start gap-2.5 rounded-lg bg-accent-100/70 border border-accent-200 px-4 py-3">
              <i className="ri-lightbulb-line text-accent-700 text-lg mt-0.5" />
              <p className="text-sm text-accent-900">
                小提示：把本页设为浏览器主页，或在手机主屏放一个图标，基本上就不会再「走丢」了。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}